/** Default map center (Manila) when no site pin exists yet. */
export const DEFAULT_SITE_PIN_CENTER: [number, number] = [14.5995, 120.9842]

/** ~5m — treat as "pin not moved" vs store/search origin. */
export const PIN_MOVE_EPSILON = 0.00005

export type DispatchCoordinateSource =
  | 'store'
  | 'store_geocoded_address'
  | 'location'
  | 'nominatim'
  | 'manual_pin'

export function hasFiniteCoords(
  latitude?: number | null,
  longitude?: number | null,
): boolean {
  return (
    latitude != null &&
    Number.isFinite(Number(latitude)) &&
    longitude != null &&
    Number.isFinite(Number(longitude))
  )
}

export function coordsApproximatelyEqual(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number,
  epsilon = PIN_MOVE_EPSILON,
): boolean {
  return Math.abs(lat1 - lat2) <= epsilon && Math.abs(lng1 - lng2) <= epsilon
}

export function formatPinnedDisplayName(latitude: number, longitude: number): string {
  return `Pinned location (${latitude.toFixed(5)}, ${longitude.toFixed(5)})`
}

/**
 * Recommend by lat/lng when the site pin is free-text, store-address geocode,
 * or a manually adjusted pin (including mall tenant corrections).
 */
export function usesCoordinateRecommendations(coordinateSource?: DispatchCoordinateSource | string | null): boolean {
  return (
    coordinateSource === 'location' ||
    coordinateSource === 'nominatim' ||
    coordinateSource === 'store_geocoded_address' ||
    coordinateSource === 'manual_pin'
  )
}

/** True when the draft pin differs from the origin coords used when the location was selected. */
export function isPinMovedFromOrigin(
  draftLat: number,
  draftLng: number,
  originLat?: number | null,
  originLng?: number | null,
): boolean {
  if (!hasFiniteCoords(originLat, originLng)) return true
  return !coordsApproximatelyEqual(draftLat, draftLng, Number(originLat), Number(originLng))
}
